import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    className: 'onboarding-step-3',

    events: {
        'click input[name="use_case"]' : 'onSelectUseCase',
        'click .back-btn'              : 'onBack',
        'submit form'                  : 'onSubmit'
    },

    dom_handlers: {
        onSelectUseCase: function(e) {
            this.$el.find('button:submit').prop('disabled', false);
        },

        onBack: function() {
            this.trigger('back');
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('form button:submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action:  'account/saveDetails',
                data: {
                    use_case: form_data.use_case
                },
                success: () => {
                    Cache.account.set('use_case', form_data.use_case);

                    this.trigger('complete');
                }
            });
        }
    },

    render: function() {
        var use_cases = [
            'Web application feedback',
            'Website feedback',
            'Client web projects',
            'Bug tracking',
            'User acceptance testing',
            'QA testing',
            'Feature validation'
        ];

        use_cases = Util.shuffleArray(use_cases);

        var radio_buttons = '';

        use_cases.forEach((use_case, index) => {
            radio_buttons +=
            '<div class="margin-bottom-8">' +
                '<input type="radio" name="use_case" id="use_case_' + index + '" value="' + use_case + '" required>' +
                '<label for="use_case_' + index + '">' + use_case + '</label>' +
            '</div>';
        });

        var content =
        '<h1 class="text-align-center"><b>One last question</b></h1>' +
        '<p class="text-align-center margin-bottom-32">What\'s your primary use case of Userback?</p>' +
        '<form>' +
            radio_buttons +
            '<div class="onboarding-footer">' +
                '<div><button type="button" class="back-btn tertiary small min">Back</button></div>' +
                '<div>3 of 3</div>' +
                '<div><button type="submit" class="primary small min" disabled>Done</button></div>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        return this;
    }
});